import { Type } from 'class-transformer';
import { RequestMapping } from '@data/common/pagination/RequestMapping';

export class BaseCriteriaDTO {
  sortOrders: string;

  searchPhrase: string;

  @Type(() => Number)
  excludedIds: number[];

  @Type(() => Number)
  includedIds: number[];

  mapping: RequestMapping;
}
